@if (consent.bannerVisible() && !customizeOpen()) {
  <div
    class="cookie-slide-in fixed z-50 left-4 right-4 bottom-[max(1rem,env(safe-area-inset-bottom))] rounded-2xl border-2 border-blue-700 bg-white shadow-2xl sm:right-auto sm:w-[20rem]"
    role="dialog"
    aria-modal="false"
    aria-labelledby="cookie-banner-title"
    aria-describedby="cookie-banner-description"
  >
    <div class="p-3.5">
      <h2 id="cookie-banner-title" class="mb-2 flex items-center gap-2 text-base font-bold text-slate-900">
        <span aria-hidden="true">🍪</span>
        {{ 'COOKIE_BANNER.TITLE' | translate }}
      </h2>

      <p id="cookie-banner-description" class="mb-1.5 text-xs leading-relaxed text-slate-700">
        {{ 'COOKIE_BANNER.DESCRIPTION' | translate }}
      </p>
      <a
        [routerLink]="paths.segments('cookiePolicy')"
        class="mb-3 inline-block text-[11px] font-medium text-blue-700 hover:text-blue-800 hover:underline focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600 rounded"
      >
        {{ 'COOKIE_BANNER.LEARN_MORE' | translate }}
      </a>

      <div class="flex flex-col gap-1.5">
        <button
          type="button"
          (click)="acceptAll()"
          class="cursor-pointer w-full rounded-lg bg-blue-700 px-3 py-2 text-xs font-medium text-white shadow-sm transition-colors hover:bg-blue-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2"
        >
          {{ 'COOKIE_BANNER.ACCEPT_ALL' | translate }}
        </button>
        <button
          type="button"
          (click)="rejectAll()"
          class="cursor-pointer w-full rounded-lg bg-blue-700 px-3 py-2 text-xs font-medium text-white shadow-sm transition-colors hover:bg-blue-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2"
        >
          {{ 'COOKIE_BANNER.REFUSE' | translate }}
        </button>
        <button
          type="button"
          (click)="openCustomize()"
          class="cursor-pointer w-full rounded-lg border border-slate-300 bg-white px-3 py-1.5 text-xs font-medium text-slate-700 transition-colors hover:bg-slate-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2"
        >
          {{ 'COOKIE_BANNER.CUSTOMIZE' | translate }}
        </button>
      </div>
    </div>
  </div>
}

@if (consent.bannerVisible() && customizeOpen()) {
  <div
    class="cookie-fade-in fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-slate-900/15 backdrop-blur-[2px] p-0 sm:p-4"
    role="dialog"
    aria-modal="true"
    aria-labelledby="cookie-customize-title"
    (click)="closeCustomize()"
  >
    <div
      class="max-h-[min(92dvh,92vh)] w-full max-w-lg overflow-y-auto rounded-t-2xl sm:rounded-2xl bg-white shadow-2xl"
      (click)="$event.stopPropagation()"
    >
      <div class="sticky top-0 rounded-t-2xl border-b border-slate-200 bg-white px-4 py-3 sm:px-6 sm:py-4">
        <div class="flex items-start justify-between gap-3">
          <h2 id="cookie-customize-title" class="min-w-0 flex-1 flex items-center gap-2 text-lg font-bold text-slate-900 sm:text-xl">
            <span aria-hidden="true">🍪</span>
            {{ 'COOKIE_BANNER.CUSTOMIZE_TITLE' | translate }}
          </h2>
          <button
            type="button"
            (click)="closeCustomize()"
            class="cursor-pointer shrink-0 rounded text-slate-400 transition-colors hover:text-slate-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600"
            [attr.aria-label]="'COOKIE_BANNER.CUSTOMIZE_CLOSE' | translate"
          >
            <svg class="size-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <p class="mt-2 text-sm text-slate-600">
          {{ 'COOKIE_BANNER.CUSTOMIZE_INTRO' | translate }}
        </p>
      </div>

      <div class="space-y-4 px-4 py-4 sm:px-6 sm:py-6">
        <div class="rounded-xl border-2 border-slate-200 bg-slate-50 p-4 sm:p-5">
          <div class="flex items-start justify-between gap-3">
            <div class="min-w-0 flex-1">
              <div class="mb-2 flex flex-wrap items-center gap-2">
                <h3 class="text-base font-bold text-slate-900 sm:text-lg">{{ 'COOKIE_BANNER.ESSENTIAL_TITLE' | translate }}</h3>
                <span class="rounded-full bg-green-100 px-2 py-0.5 text-xs font-semibold whitespace-nowrap text-green-800">
                  {{ 'COOKIE_BANNER.ESSENTIAL_BADGE' | translate }}
                </span>
              </div>
              <p class="text-xs leading-relaxed text-slate-700 sm:text-sm">
                {{ 'COOKIE_BANNER.ESSENTIAL_BODY' | translate }}
              </p>
            </div>
            <div
              class="relative h-5 w-10 shrink-0 rounded-full bg-green-500 sm:h-6 sm:w-12"
              aria-hidden="true"
            >
              <span class="absolute top-0.5 right-0.5 size-4 rounded-full bg-white sm:top-1 sm:right-1"></span>
            </div>
          </div>
        </div>

        <div class="rounded-xl border-2 border-slate-200 bg-white p-4 sm:p-5">
          <div class="flex items-start justify-between gap-3">
            <div class="min-w-0 flex-1">
              <h3 class="mb-2 text-base font-bold text-slate-900 sm:text-lg">{{ 'COOKIE_BANNER.ANALYTICS_TITLE' | translate }}</h3>
              <p class="mb-2 text-xs leading-relaxed text-slate-700 sm:text-sm">
                {{ 'COOKIE_BANNER.ANALYTICS_BODY' | translate }}
              </p>
              <p class="text-xs text-slate-500 italic">
                {{ 'COOKIE_BANNER.ANALYTICS_NOTE' | translate }}
              </p>
            </div>
            <button
              type="button"
              role="switch"
              [attr.aria-checked]="analyticsEnabled()"
              (click)="toggleAnalytics()"
              class="relative h-6 w-11 shrink-0 cursor-pointer rounded-full transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2"
              [class.bg-blue-700]="analyticsEnabled()"
              [class.bg-slate-300]="!analyticsEnabled()"
              [attr.aria-label]="'COOKIE_BANNER.ANALYTICS_TITLE' | translate"
            >
              <span
                class="absolute top-0.5 left-0.5 size-5 rounded-full bg-white shadow transition-transform"
                [class.translate-x-5]="analyticsEnabled()"
              ></span>
            </button>
          </div>
        </div>
      </div>

      <div class="sticky bottom-0 rounded-b-2xl border-t border-slate-200 bg-slate-50 px-4 py-3 sm:px-6 sm:py-4 pb-[max(0.75rem,env(safe-area-inset-bottom))]">
        <div class="flex flex-col gap-2 sm:flex-row sm:justify-end sm:gap-3">
          <button
            type="button"
            (click)="closeCustomize()"
            class="cursor-pointer w-full sm:w-auto rounded-lg border border-slate-300 bg-white px-4 py-2.5 text-sm font-medium text-slate-700 transition-colors hover:bg-slate-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600 sm:px-5"
          >
            {{ 'COOKIE_BANNER.BACK' | translate }}
          </button>
          <button
            type="button"
            (click)="saveCustom()"
            class="cursor-pointer w-full sm:w-auto rounded-lg bg-blue-700 px-4 py-2.5 text-sm font-medium text-white transition-colors hover:bg-blue-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600 sm:px-5"
          >
            {{ 'COOKIE_BANNER.SAVE' | translate }}
          </button>
        </div>
        <p class="mt-3 text-center text-xs text-slate-500">
          {{ 'COOKIE_BANNER.FOOTER_HINT' | translate }}
        </p>
      </div>
    </div>
  </div>
}
